<script setup lang="ts">
  const { runAppInitActions } = useAppInit();

  runAppInitActions();
</script>

<template>
  <UApp>
    <NuxtLayout>
      <NuxtPage />
    </NuxtLayout>
  </UApp>
</template>
